import script from "./SavingIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavingIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress,QTooltip});
